import { Input } from '@ordo/ui/input'
import { TemplateEditor } from 'pages/templates/template-editor'

export interface LayoutFormData {
  name: string
  slug: string
  body: string
}

export interface LayoutFormFieldsProps {
  data: LayoutFormData
  onChange: (field: keyof LayoutFormData, value: string) => void
  /** Locked on edit pages so consuming services don't break on a rename. */
  slugLocked?: boolean
}

export function LayoutFormFields({ data, onChange, slugLocked }: LayoutFormFieldsProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="space-y-1.5">
        <label htmlFor="layoutName" className="text-sm font-medium text-muted-foreground">
          Name
        </label>
        <Input id="layoutName" value={data.name} onChange={(e) => onChange('name', e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <label htmlFor="layoutSlug" className="text-sm font-medium text-muted-foreground">
          Slug
        </label>
        <Input
          id="layoutSlug"
          value={data.slug}
          onChange={(e) => onChange('slug', e.target.value)}
          disabled={slugLocked}
          placeholder="auto-generated from name"
        />
        <p className="text-xs text-muted-foreground">
          {slugLocked
            ? 'Slugs are locked after creation — consuming services hardcode them.'
            : 'Stable identifier. Lowercase, digits, and dashes only. Auto-fills from name.'}
        </p>
      </div>
      <div className="flex min-h-0 flex-1 flex-col space-y-1.5">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-muted-foreground">Layout Body (HTML)</span>
          <span className="text-xs text-muted-foreground">
            Must contain <code className="rounded bg-muted px-1 font-mono">{'{{ content }}'}</code>
          </span>
        </div>
        <TemplateEditor value={data.body} onChange={(v) => onChange('body', v)} mode="html" />
      </div>
    </div>
  )
}
